export const TRANSACTION_HISTORY_HEADERS = [
  { key: "index", title: "all.table.head.col-1", sort: false, className: "u-pl-6" },
  { key: "id", title: "all.table.head.col-2", sort: true },
  { key: "status", title: "all.table.head.col-3", sort: false },
  { key: "beneficiary_bank", title: "all.table.head.col-4", sort: true },
  { key: "beneficiary_name", title: "all.table.head.col-5", sort: true },
  { key: "account_number", title: "all.table.head.col-6", sort: false },
  { key: "amount", title: "all.table.head.col-7", sort: true },
  { key: "beneficiary_email", title: "all.table.head.col-8", sort: true },
  { key: "remark", title: "all.table.head.col-9", sort: false },
  { key: "action", title: "all.table.head.col-10", sort: false },
  { key: "user_name", title: "all.table.head.col-11", sort: true },
  { key: "created_at", title: "all.table.head.col-12", sort: true },
  { key: "completed_at", title: "all.table.head.col-13", sort: true }
];

export const TRANSACTION_HISTORY_HEADERS_SEABANK = [
  { key: "index", title: "all.table.head-seabank.col-1", sort: false },
  { key: "id", title: "all.table.head-seabank.col-2", sort: true },
  { key: "status", title: "all.table.head-seabank.col-3", sort: false },
  { key: "beneficiary_bank", title: "all.table.head-seabank.col-4", sort: true },
  { key: "beneficiary_name", title: "all.table.head-seabank.col-5", sort: true },
  { key: "account_number", title: "all.table.head-seabank.col-6", sort: false },
  { key: "amount", title: "all.table.head-seabank.col-7", sort: true },
  { key: "remark", title: "all.table.head-seabank.col-9", sort: false },
  { key: "user_name", title: "all.table.head-seabank.col-11", sort: true },
  { key: "created_at", title: "all.table.head-seabank.col-12", sort: true },
  { key: "confirmed_at", title: "all.table.head-seabank.col-13", sort: true },
  { key: "completed_at", title: "all.table.head-seabank.col-14", sort: true }
];

export const TRANSACTION_HISTORY_HEADERS_SEABANK_CHARGE_FEE = [
  { key: "index", title: "all.table.head-seabank.col-1", sort: false },
  { key: "id", title: "all.table.head-seabank.col-2", sort: true },
  { key: "status", title: "all.table.head-seabank.col-3", sort: false },
  { key: "beneficiary_bank", title: "all.table.head-seabank.col-4", sort: true },
  { key: "beneficiary_name", title: "all.table.head-seabank.col-5", sort: true },
  { key: "account_number", title: "all.table.head-seabank.col-6", sort: false },
  { key: "total_amount", title: "all.table.head-seabank.col-7", sort: true },
  { key: "fee", title: "all.table.head-seabank.col-15", sort: true },
  { key: "amount", title: "all.table.head-seabank.col-16", sort: true },
  { key: "remark", title: "all.table.head-seabank.col-9", sort: false },
  { key: "user_name", title: "all.table.head-seabank.col-11", sort: true },
  { key: "created_at", title: "all.table.head-seabank.col-12", sort: true },
  { key: "confirmed_at", title: "all.table.head-seabank.col-13", sort: true },
  { key: "completed_at", title: "all.table.head-seabank.col-14", sort: true }
];

export const OLD_TRANSACTION_HISTORY_HEADERS = [
  { key: "index", title: "all.table.head.col-1", sort: false },
  { key: "id", title: "all.table.head.col-2", sort: true },
  { key: "status", title: "all.table.head.col-3", sort: false },
  { key: "beneficiary_bank", title: "all.table.head.col-4", sort: true },
  { key: "beneficiary_name", title: "all.table.head.col-5", sort: true },
  { key: "account_number", title: "all.table.head.col-6", sort: false },
  { key: "amount", title: "all.table.head.col-7", sort: true },
  { key: "remark", title: "all.table.head.col-9", sort: false },
  { key: "user_name", title: "all.table.head.col-11", sort: true },
  { key: "created_at", title: "all.table.head.col-12", sort: true },
  { key: "completed_at", title: "all.table.head.col-13", sort: true }
];

export const OLD_TRANSACTION_HISTORY_HEADERS_CHARGE_FEE = [
  { key: "index", title: "all.table.head.col-1", sort: false },
  { key: "id", title: "all.table.head.col-2", sort: true },
  { key: "status", title: "all.table.head.col-3", sort: false },
  { key: "beneficiary_bank", title: "all.table.head.col-4", sort: true },
  { key: "beneficiary_name", title: "all.table.head.col-5", sort: true },
  { key: "account_number", title: "all.table.head.col-6", sort: false },
  { key: "total_amount", title: "all.table.head-seabank.col-7", sort: true },
  { key: "fee", title: "all.table.head-seabank.col-15", sort: true },
  { key: "amount", title: "all.table.head-seabank.col-16", sort: true },
  { key: "remark", title: "all.table.head.col-9", sort: false },
  { key: "user_name", title: "all.table.head.col-11", sort: true },
  { key: "created_at", title: "all.table.head.col-12", sort: true },
  { key: "completed_at", title: "all.table.head.col-13", sort: true }
];

export const INTERNATIONAL_TRANSACTION_HISTORY_HEADERS = [
  { key: "index", title: "international-transaction.table.head.col-1", sort: false },
  { key: "id", title: "international-transaction.table.head.col-2", sort: false },
  { key: "status", title: "international-transaction.table.head.col-10", sort: false },
  { key: "destination_country", title: "international-transaction.table.head.col-4", sort: false },
  { key: "bank_name", title: "international-transaction.table.head.col-5", sort: false },
  { key: "beneficiary_name", title: "international-transaction.table.head.col-7", sort: false },
  { key: "account_number", title: "international-transaction.table.head.col-6", sort: false },
  { key: "amount", title: "international-transaction.table.head.col-8", sort: false },
  { key: "beneficiary_amount", title: "international-transaction.table.head.col-9", sort: false },
  // created date is hidden
  // { key: "user_name", title: "international-transaction.table.head.col-3", sort: false },
  { key: "created_at", title: "international-transaction.table.head.col-11", sort: false },
  { key: "completed_at", title: "international-transaction.table.head.col-12", sort: false }
];

export const MULTIPLE_INTERNATIONAL_TRANSACTION_HISTORY_HEADERS = [
  { key: "index", title: "international-transaction.multi.table.head.col-1", sort: false },
  { key: "id", title: "international-transaction.multi.table.head.col-2", sort: true },
  { key: "status", title: "international-transaction.multi.table.head.col-8", sort: true },
  { key: "payment_method", title: "international-transaction.multi.table.head.col-4", sort: true },
  { key: "amount", title: "international-transaction.multi.table.head.col-5", sort: true },
  { key: "total_amount", title: "international-transaction.multi.table.head.col-6", sort: true },
  { key: "total_beneficiary", title: "international-transaction.multi.table.head.col-7", sort: true },
  { key: "user_name", title: "international-transaction.multi.table.head.col-3", sort: true },
  { key: "created_at", title: "international-transaction.multi.table.head.col-9", sort: true },
  { key: "completed_at", title: "international-transaction.multi.table.head.col-10", sort: true }
];

export const MULTIPLE_TRANSACTION_HEADERS = [
  { key: "index", title: "multi.table.head.col-1", sort: false },
  { key: "id", title: "multi.table.head.col-2", sort: true },
  { key: "status", title: "multi.table.head.col-3", sort: false },
  { key: "sender_bank", title: "multi.table.head.col-4", sort: true },
  { key: "amount", title: "multi.table.head.col-5", sort: true },
  { key: "total_beneficiaries", title: "multi.table.head.col-7", sort: true },
  { key: "user_name", title: "multi.table.head.col-10", sort: true },
  { key: "action", title: "multi.table.head.col-9" },
  { key: "created_at", title: "multi.table.head.col-11", sort: true },
  { key: "completed_at", title: "multi.table.head.col-12", sort: true },
  { key: "redirect-button", title: "" }
];

export const OLD_MULTIPLE_TRANSACTION_HEADERS = [
  { key: "index", title: "multi.table.head.col-1", sort: false },
  { key: "id", title: "multi.table.head.col-2", sort: true },
  { key: "status", title: "multi.table.head.col-3", sort: false },
  { key: "sender_bank", title: "multi.table.head.col-4", sort: true },
  { key: "amount", title: "multi.table.head.col-5", sort: true },
  { key: "total_amount", title: "multi.table.head.col-6", sort: true },
  { key: "total_children", title: "multi.table.head.col-7", sort: true },
  { key: "user_name", title: "multi.table.head.col-10", sort: true },
  { key: "created_at", title: "multi.table.head.col-11", sort: true },
  { key: "completed_at", title: "multi.table.head.col-12", sort: true }
];

export const TRANSACTION_APPROVAL_HEADERS = [
  { key: "index", title: "draft.table.head.col-1", sort: false },
  { key: "id", title: "draft.table.head.col-2", sort: false },
  { key: "user_name", title: "draft.table.head.col-3", sort: true },
  { key: "total_amount", title: "draft.table.head.col-4", sort: true },
  { key: "total_children", title: "draft.table.head.col-5", sort: true },
  { key: "created_at", title: "draft.table.head.col-6", sort: true },
  { key: "status", title: "draft.table.head.col-7", sort: false }
];

export const ACCOUNT_INQUIRY_HEADERS = [
  { key: "index", title: "account-inquiry.table.col-1", sort: false },
  { key: "user_name", title: "account-inquiry.table.col-2", sort: false },
  { key: "bank", title: "account-inquiry.table.col-3", sort: false },
  { key: "account_number", title: "account-inquiry.table.col-4", sort: false },
  { key: "status", title: "account-inquiry.table.col-5", sort: false },
  { key: "created_at", title: "account-inquiry.table.col-6", sort: false }
];

export const DEPOSIT_DETAIL_HEADERS = [
  { key: "col-1", title: "summary.modal.table.col-1" },
  { key: "col-2", title: "summary.modal.table.col-2" },
  { key: "col-3", title: "summary.modal.table.col-3" },
  { key: "col-4", title: "summary.modal.table.col-4" },
  { key: "col-5", title: "summary.modal.table.col-5" }
];

export const INTERNATIONAL_TRANSFER_DETAIL_HEADERS = [
  { key: "col-1", title: "modal.table.col-1" },
  { key: "col-2", title: "modal.table.col-2" },
  { key: "col-3", title: "modal.table.col-3" },
  { key: "col-4", title: "modal.table.col-4" },
  { key: "col-5", title: "modal.table.col-5" },
  { key: "col-6", title: "modal.table.col-6" },
  { key: "col-7", title: "modal.table.col-7" }
];
